import React, { useMemo } from 'react'
import qs from 'qs'
import { useInspirationContext } from './inspirationTree.context'
import CustomizeHeader from '../../components/header/customizeHeader'
import { SearchBtn } from '../../components/header'
import HeaderBreadcrumb from './headerBreadcrumb'

export default ({ auth }) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const inspirationTree = useInspirationContext()

  const rootInspirationId = useMemo(() => {
    return inspirationTree?.getRootByValue(query.inspirationId)?.value
  }, [inspirationTree, location])

  return <CustomizeHeader
    style={{ zIndex: 100 }}
    renderLeft={() => <div className="mn-idea-mass-detail-header-left">{query.shareUrl ? null : <HeaderBreadcrumb />}</div>}
  >
    {auth.includes('F14') && <SearchBtn inspirationId={rootInspirationId} />}
  </CustomizeHeader>
}
